import axios from 'axios';
import * as webfontloader from 'webfontloader';

class FontService {
  constructor() {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_FONTSERVICE
    });
  }

  getFonts(FontLimit = 50) {
    return this.http.get('/api/font/polle').then(({ data }) => {
      const { fonts } = data;
      return fonts.slice(0, FontLimit);
    });
  }

  load() {
    return this.getFonts().then(fonts => {
      return new Promise(resolve => {
        webfontloader.load({
          custom: {
            families: fonts.map(font => font.name),
            urls: [`${process.env.VUE_APP_FONTSERVICE}/api/css/polle`]
          },
          fontactive() {
            resolve(fonts);
          }
        });
      });
    });
  }
}

export default new FontService();
